
export const settings = {

    APP_NAME: "Human Resource Development",
    API_SERVER: (process.env.VUE_APP_API_SERVER || 'https://ihris-dev.dh.moh.gov.et/hrd/api/').replace(/\/+$/, '') + '/',

    FRONT_URL:'https://hrd.moh.gov.et/',
    // FRONT_URL:'https://dev-hrd.sandboxaddis.com/',
    // FRONT_URL:'http://localhost:8080/',
};
